import { useLauncherStore } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherStoreContext";
import clsx from "clsx";
import type { ReactNode } from "react";

export default function FooterWrapper({
  gap,
  padded,
  children,
}: {
  gap?: boolean;
  padded?: boolean;
  children?: ReactNode;
}) {
  const isOpen = useLauncherStore((state) => state.isOpen);

  return (
    <div
      className={clsx(
        "footer flex flex-col items-center justify-center bg-white dark:border-gray-700 dark:bg-gray-900",
        "relative", // Ensure box-shadow is visible in front of the body
        gap && "gap-1",
        "rounded-b-[inherit] [&>*:last-child]:rounded-b-[inherit]",
        padded && "py-2",
      )}
      style={{
        boxShadow: isOpen ? "0px -0.5px 16px 0px rgba(0, 0, 0, 0.12)" : undefined,
      }}
    >
      {children}
    </div>
  );
}
